import { useLocation } from "react-router-dom";
import Icon from "@material-tailwind/react/Icon";

export default function AdminNavbar({ showSidebar, setShowSidebar }) {
	const location = useLocation().pathname;

	return (
		<nav className="bg-surface/90 backdrop-blur-md md:ml-64 py-4 px-3 border-b border-white/20 shadow-sm sticky top-0 z-10 transition-all duration-300">
			<div className="container max-w-full mx-auto flex items-center justify-between md:pr-8 md:pl-10">
				<div className="md:hidden">
					<button className="text-text-muted hover:text-primary p-2 focus:outline-none" onClick={() => setShowSidebar("left-0")}>
						<Icon name="menu" size="2xl" color="black" />
					</button>
					<div
						className={`absolute top-2 md:hidden ${
							showSidebar === "left-0" ? "left-64" : "-left-64"
						} z-50 transition-all duration-300`}
					>
						<button className="text-text-muted hover:text-danger p-2 focus:outline-none" onClick={() => setShowSidebar("-left-64")}>
							<Icon name="close" size="2xl" color="black" />
						</button>
					</div>
				</div>

				<div className="flex justify-between items-center w-full">
					<h4 className="uppercase text-text-heading text-sm tracking-wider mt-1 font-bold">
						{location.toUpperCase().replace("/", "")}
					</h4>
				</div>
			</div>
		</nav>
	);
}
